import { createTheme } from '@mui/material';
import {grey} from '@mui/material/colors'
export const Tema = createTheme({
  palette:{
    primary:{
      main:grey[700],
      dark:grey[700],
    }
  }
});